__turbopack_context__.v({
  "container": "AppInput-module-scss-module__1wbPSa__container",
  "error": "AppInput-module-scss-module__1wbPSa__error",
  "errorMessage": "AppInput-module-scss-module__1wbPSa__errorMessage",
  "iconSpan": "AppInput-module-scss-module__1wbPSa__iconSpan",
  "input": "AppInput-module-scss-module__1wbPSa__input",
  "inputContainer": "AppInput-module-scss-module__1wbPSa__inputContainer",
  "inputField": "AppInput-module-scss-module__1wbPSa__inputField",
  "label": "AppInput-module-scss-module__1wbPSa__label",
  "myIcon": "AppInput-module-scss-module__1wbPSa__myIcon",
  "required": "AppInput-module-scss-module__1wbPSa__required",
});
